import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { ContactButton } from '../../../components/UI/Buttons';

const HeaderPage = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        height: { xs: '100vh', md: '95vh', lg: '90vh' },
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        py: 6,
        pt: 10,
      }}
    >
      <Container sx={{ maxWidth: { xs: '100%', sm: '100%', md: '100%', lg: '90%' } }}>
        <Paper
          elevation={3}
          sx={{
            display: 'flex',
            overflow: 'hidden',
            borderRadius: 8,
            bgcolor: 'primaryDark.main',
            height: { xs: '90vh', md: '80vh', lg: '75vh' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              height: '100%',
              px: { xs: 2, sm: 4, md: 6, lg: 8 },
              py: { xs: 4, sm: 6, md: 8, lg: 12, xl: 16 },
              gap: 4,
            }}
          >
            <Typography
              sx={{
                lineHeight: 1.2,
                mb: 2,
                fontSize: { xs: '2.3em', sm: '3em', md: '3.5em', lg: '4em' },
                fontWeight: 700,
                textTransform: 'uppercase',
                color: 'white',
                maxWidth: { xs: '95%', sm: '100%', md: '95%', lg: '90%', xl: '75%' },
              }}
            >
              Inteligencia Artificial Experta en la Industria Automotriz
            </Typography>
            <Typography
              variant="subtitle1"
              color="white"
              sx={{
                fontSize: '1.2em',
                marginBottom: '16px',
              }}
            >
              Conduzcamos a una mejor conversión de Leads.
            </Typography>
            <ContactButton
              variant="contained"
              sx={{
                mt: 2,
                width: 'fit-content',
                fontSize: { xs: '1em', sm: '1em', md: '1.2em', lg: '1.3em', xl: '1.5em' },
              }}
              onClick={() => window.open('https://zcal.co/bbustos', '_blank', 'noopener,noreferrer')}
            >
              Agendar una demo
            </ContactButton>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default HeaderPage;
